import {course_getCourses_Api} from 'apis'
import {getId} from 'apis/model/base'
import classNames from 'classnames'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import useAsyncWithCache from 'modules/asyncCache/useAsyncWithCache'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useMemo, useState} from 'react'
import {branch, compose, renderNothing} from 'recompose'
import AntdConfigWrapper, {RenderEmptyMeta,} from 'views/AppLocals/custom/AntdConfigWrapper'
import {reactSelectComponents, SelectWidget,} from 'views/AppLocals/custom/ReactSelectComponents'
import {bindQueryParams,} from 'views/AppLocals/functions/routerHelper'
import {getResponseItems, NullAsDefault} from 'views/Shared'

const FilterSelectField = ({
                             name,
                             value,
                             onChange,
                             options,
                             isLoading,
                             className,
                             ...props
                           }) => (
  <AntdConfigWrapper renderEmpty={RenderEmptyMeta}>
    <SelectWidget
      value={_.find(options, {value}) ? value : undefined}
      showSearch={true}
      allowClear={true}
      onChange={(value) => {
        onChange(name, value)
      }}
      loading={!!isLoading}
      optionFilterProp="label"
      className={classNames('CenterSelector w-full', className)}
      options={!!isLoading ? [] : options}
      suffixIcon={
        !!isLoading ? undefined : <reactSelectComponents.DropdownIndicator/>
      }
      // Cho panel dropdown tự co theo nội dung dài nhất thay vì bó theo đúng
      // bề rộng ô, tránh tên khóa học dài bị cắt chữ khi mở danh sách chọn.
      popupMatchSelectWidth={false}
      {...props}
    />
  </AntdConfigWrapper>
)

// Label phía trên, control phía dưới
const FilterField = ({label, className, children}) => (
  <div className={classNames('flex flex-col gap-1', className)}>
    <span className="text-2xs font-semibold text-color-300 uppercase tracking-wider whitespace-no-wrap">
      {label}
    </span>
    {children}
  </div>
)

const CourseAsyncWrapper = compose(
  branch(
    ({owner_id, owner_type}) => _.some([owner_id, owner_type], _.isEmpty),
    renderNothing
  )
)(({owner_id, owner_type, children}) => {
  const [values, setValues] = useState()

  const apiInfo = course_getCourses_Api

  const cacheId = useMemo(
    () =>
      [
        apiInfo.path.replace(':id', owner_id).replace(':type', owner_type),
        JSON.stringify(values),
      ].join('/'),
    [values, owner_id, owner_type]
  )

  const {response, isLoading} = useAsyncWithCache({
    values,
    cacheId,
    apiInfo,
    query: bindQueryParams([{id: owner_id}, {type: owner_type}]),
  })

  return _.isFunction(children)
    ? children({
      isLoading,
      items: getResponseItems(response),
      onSearch: (keyword) => {
        setValues({
          keyword,
        })
      },
    })
    : children
})

// Chỉ giữ lại lọc theo Khóa đào tạo — bỏ Môn học/Lớp học cho gọn, việc lọc
// theo thời gian đã có Năm/Tháng đảm nhiệm riêng (CalendarNavControls).
export const CouseClassTimetableFilter = ({
                                            owner_id,
                                            owner_type,
                                            defaultValue,
                                            value: filter = {
                                              course_id: undefined,
                                            },
                                            onChange: setValues = NullAsDefault,
                                          }) => {
  const t = useTranslate()

  const handleChange = useCallback(
    (name, value) => {
      const params = {
        ...filter,
        [name]: value,
      }
      setValues(params)
      return params
    },
    [filter]
  )

  return (
    <CourseAsyncWrapper {...{owner_id, owner_type}}>
      {({items, isLoading}) => {
        const options = Array.from(items).map((option) => ({
          value: getId(option),
          label: getTitle(option),
        }))
        return (
          <FilterField label={t('course')} className="w-64">
            <FilterSelectField
              name="course_id"
              loading={isLoading}
              value={filter.course_id}
              placeholder={t(isLoading ? 'loading...' : 'course')}
              options={options}
              onChange={handleChange}
            />
          </FilterField>
        )
      }}
    </CourseAsyncWrapper>
  )
}

export default CouseClassTimetableFilter
